import { auth } from './config';

const API_URL = (import.meta.env.VITE_API_BASE_URL || '') + '/api/clients';
const ADMIN_API_URL = (import.meta.env.VITE_API_BASE_URL || '') + '/api/admin';

const getAuthToken = async () => {
    const user = auth.currentUser;
    if (!user) throw new Error("Usuario no autenticado");
    return await user.getIdToken();
};

export const checkAdminStatus = async () => {
    try {
        const token = await getAuthToken();
        const response = await fetch(`${ADMIN_API_URL}/status`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) return false;
        const data = await response.json();
        return data.isAdmin;
    } catch (error) {
        console.error("Error en checkAdminStatus:", error);
        return false;
    }
};

export const getClientProfile = async () => {
    try {
        const token = await getAuthToken();
        const response = await fetch(`${API_URL}/profile`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) {
            if (response.status === 404) return null;
            throw new Error('Error al obtener perfil');
        }
        return await response.json();
    } catch (error) {
        console.error("Error en getClientProfile:", error);
        throw error;
    }
};

export const getClientTransactions = async () => {
    try {
        const token = await getAuthToken();
        const response = await fetch(`${API_URL}/transactions`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error al obtener transacciones');
        return await response.json();
    } catch (error) {
        console.error("Error en getClientTransactions:", error);
        throw error;
    }
};

export const getInvoiceBlobUrl = async (transactionId) => {
    try {
        const token = await getAuthToken();
        const response = await fetch(`${API_URL}/transactions/${transactionId}/invoice`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error al obtener factura');
        const blob = await response.blob();
        return URL.createObjectURL(blob);
    } catch (error) {
        console.error("Error en getInvoiceBlobUrl:", error);
        throw error;
    }
};



export const uploadReceipt = async (suscripcionId, amount, file) => {
    try {
        const token = await getAuthToken();
        const formData = new FormData();
        formData.append('suscripcionId', suscripcionId);
        formData.append('amount', amount);
        formData.append('receipt', file);

        const response = await fetch(`${API_URL}/upload-receipt`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
                // No Content-Type header, fetch adds it automatically with boundary for FormData
            },
            body: formData
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error al subir comprobante');
        }

        return await response.json();
    } catch (error) {
        console.error("Error en uploadReceipt:", error);
        throw error;
    }
};